export var isByteDanceNet = function isByteDanceNet() {
  return location.href.indexOf('localhost') > -1 || location.href.indexOf(""+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"") > -1;
};